import {
  SPOR_TOTO_SOCIAL_COUPON_REQUEST,
  SPOR_TOTO_SOCIAL_COUPON_SUCCESS,
  SPOR_TOTO_SOCIAL_COUPON_FAILURE
} from 'Store/constants';
  
const initialState = {
  data: {},
  isLoading: null,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_SOCIAL_COUPON_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
  
    case SPOR_TOTO_SOCIAL_COUPON_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: null
      };
  
    case SPOR_TOTO_SOCIAL_COUPON_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
  
    default:
      return state;
  }
};
  